export const COMPRESS_ON_NARROW_CLASS_NAMES =
  'leading-tight sm:leading-normal [&_p]:text-xs sm:[&_p]:text-base';
